import { Feature, Module } from "__generated__/gql/graphql";
import { useCurrentBrandData, useCurrentUserData } from "./currentUserHooks";

export function useUserHasFeature(feature: Feature): boolean | undefined {
  const userData = useCurrentUserData();
  return userData?.features.includes(feature);
}

export function useBrandModules() {
  const brandData = useCurrentBrandData();
  return brandData?.modules;
}

export function useBrandHasModule<M extends Module>(...modules: M[]) {
  const brandModules = useBrandModules();
  return modules.map((module) => brandModules?.includes(module));
}
